import { useTherapySuppliersForm } from 'Hooks/useTherapySuppliersForm';
import { Form } from 'Modules/Suppliers/SuppliersMain/SearchForms/TherapySearchForm/Form';
import { FormProvider } from 'react-hook-form';
import { IForm } from '..';

export const TherapyForm = ({ setOpenModal, selectedOrderBy }: IForm) => {
  const { therapySuppliersForm } = useTherapySuppliersForm();
  return (
    <FormProvider {...therapySuppliersForm}>
      <Form
        formSx={{
          border: 'none',
          boxShadow: 'none',
          m: 0,
          p: 0,
          width: '100%',
          maxWidth: '100%',
          alignItems: 'flex-start',
        }}
        callback={() => setOpenModal(false)}
        selectedOrderBy={selectedOrderBy}
      />
    </FormProvider>
  );
};
